/**
 * Converts a standard JSON path to a JSON-merge-patch path.
 *
 * Examples:
 * - "user.name" -> "/user/name"
 * - "items[0].title" -> "/items/0/title"
 * - "settings.theme.colors.primary" -> "/settings/theme/colors/primary"
 * - "metadata.tags[2].value" -> "/metadata/tags/2/value"
 * - 'user.["with spaces"].name' -> "/user/with spaces/name"
 * - 'settings.["special:chars"].value' -> "/settings/special:chars/value"
 *
 * @param path The standard JSON path to convert
 * @returns The corresponding JSON-merge-patch path
 */
export function jsonPathToMergePatchPath(path: string): string {
	// Handle empty or invalid paths
	if (!path || typeof path !== "string") {
		return "/";
	}

	// Split the path into segments, handling both dot notation and array access
	const segments = path
		// Remove leading $., if present
		.replace(/^\$\./, "")
		// Replace quoted property access with a special marker
		.replace(/\.\["([^"]+)"\]/g, ".__QUOTED__$1")
		// Replace array access notation with dots
		.replace(/\[(\d+)\]/g, ".$1")
		// Split by dots
		.split(".")
		// Filter out empty segments
		.filter(Boolean)
		// Restore quoted property names
		.map((segment) => segment.replace(/^__QUOTED__/, ""));

	// Join segments with forward slashes and ensure leading slash
	return "/" + segments.join("/");
}
